import { render, staticRenderFns } from "./EmergencyServices.vue?vue&type=template&id=2bd857f2"
import script from "./EmergencyServices.vue?vue&type=script&lang=js"
export * from "./EmergencyServices.vue?vue&type=script&lang=js"
import style0 from "./EmergencyServices.vue?vue&type=style&index=0&id=2bd857f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports